import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import SarasPopup from '../../container/popup/SarasPopup';
import SarasSearchInput from '../textField/SarasSearchInput';
import { Icon } from '../../decor/SarasIcons';
import SarasTooltip from '../../notifications/SarasTooltip';
import SarasFilterMenu from '../../repeater/menu/SarasFilterMenu';
import useDeviceDetection from '../../hooks/deviceIntegration/useDeviceDetection';

const SarasSearchAC = (props) => {
  const { onSearchParamChange, onSearchFieldsRequested, onCriteriaAction, 
      inputRef, onSelection, resetSearchParam } = props;

  const [open, setOpen] = React.useState(false);
  const [searchParam, setSearchParam] = React.useState("");
  const [filterFieldList, setFilterFieldList] = React.useState([]);

  const anchorRef = React.useRef(null);

  const deviceInfo = useDeviceDetection();

  let initialiseSearchParam = function() {
    // console.log("field list 2", currentGroupKey);
    setSearchParam("");

    if(inputRef) inputRef.current.focus();
  }

  React.useEffect(initialiseSearchParam, [resetSearchParam]);

  const getFieldList = () => {
    return onSearchFieldsRequested();
  }

  const handleSelection = (event) => {
    let fieldKey = event.currentTarget.getAttribute('fieldkey');
    // console.log("clicked", fieldKey, searchParam);
    if(onSelection) onSelection(searchParam, fieldKey);
    setSearchParam("");
    setOpen(false);
    if(inputRef) inputRef.current.focus();
  };

  const handleClose = (event) => {
    setOpen(false);
  };

  const getFilteredFields = (sp) => {
    if(onSearchParamChange && sp.length > 0) {
        let fl = onSearchParamChange(sp);
        // console.log("field list returned", fl);
        setFilterFieldList(fl);
        setOpen(true);
    }
  }

  const onFilterSelected = (ref, menu) => {
// console.log("render criteria editor 1", menu, menu.rowKey);
    if(menu && onCriteriaAction) onCriteriaAction(ref, "action-select-filter", menu.rowKey);
  }

  const onSearchChange = (e, value) => {
    let sp = value;
    // console.log("search change", sp);
    setSearchParam(sp);
    getFilteredFields(sp);
  }

  // const setDatePickerValue = (datePickerRef,dateValue) => {
  //   // console.log("date picker", dateValue);
  //   setSearchParam(dateValue);
  //   getFilteredFields(dateValue);
  // }

  const onSearchFocus = (e) => {
      //open the field list on focus and if have some value in the search input
      if(searchParam.length > 0 && !open)
      {
        setOpen(true);
      }
  }

  const renderFilterMenu = () => {
      let FilterIcon = Icon['filter'];

      return (
          <SarasTooltip title={"Select Filter"}>
              <span className='uiFlexBox3 uiLink'>
                  <FilterIcon />
              </span>
          </SarasTooltip>
      )
    }

  return (
      <>
         {!deviceInfo.activateMobileView ? <div>
          <div
            ref={anchorRef}
            aria-controls={open ? 'menu-list-grow' : undefined}
            aria-haspopup="true"
            className='uiFlexBox3'
          >
            <SarasSearchInput placeholder="Search..." 
            ksc="esc"
            elevation={0}
            value={searchParam}
            inputRef={inputRef}
            className="uiAppMenuSearchBar"
            type='search' 
            onFocus={onSearchFocus} onSearchAsKeyed={onSearchChange}/>
          </div>
        </div> : null}
        <SarasFilterMenu menuTrigger={renderFilterMenu()} 
            dataList={getFieldList()} 
            onSelection={onFilterSelected}></SarasFilterMenu>
        <SarasPopup anchorRef={anchorRef} open={open} onClose={handleClose} paperStyle={{maxHeight: "300px", overflow:"auto"}}>
          <MenuList autoFocusItem={false} id="menu-list-grow" >
            {filterFieldList.map((row, index)=>(
                <MenuItem key={index} onClick={handleSelection} fieldkey={row.rowKey}>
                    {row.dataList.label}
                </MenuItem>
            ))}
          </MenuList>
        </SarasPopup>
      </>
  );
}

export default SarasSearchAC;